import React, { useEffect, useState } from "react";
import "./CBAHeader.css";
import { Link } from "react-router-dom";
import { STRING_CONSTANTS } from "../../utils/constants/stringConstants";
import { useWhitelabel } from "../../context/WhitelabelContext"; // Import our new hook! Adjust path as needed

function CBAHeader({ hideMenus = false }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 850);
  const { logoSrc } = useWhitelabel();
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToHome = () => {
    window.location.href = "/";
  };

  const currentPath = window.location.pathname;

  const isAccountsPage = window.location.pathname === '/accounts';
  const signupPath = (isAccountsPage || window.whitelabel) ? '/accounts/signup' : '/signup';
  
  return (
    <header
      className="cba-web-page-header"
      style={{ paddingBottom: hideMenus ? "20px" : "" }}
    >
      <div className="logo" onClick={goToHome} style={{ cursor: "pointer" }}>
        {logoSrc && <img src={logoSrc} alt="header logo" />}
      </div>
      {hideMenus ? (
        ""
      ) : (
        <>
          <div className="menu-icon" onClick={toggleMenu}>
            <img src="/assets/images/header-menu-icon.svg" alt="menu icon" />
          </div>
          {isMobile ? (
            <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
              <ul className="nav-links">
                <li>
                  <Link to="/">
                    Home
                  </Link>
                </li>
                <li>
                  <a href="/accounts/signup">Signup</a>
                </li>
              </ul>
              <div className="auth-buttons">
                <button className="login">Login</button>
                <button className="signup">Signup</button>
              </div>
            </nav>
          ) : (
            <>
              <ul className="nav-links">
                <li
                  className={
                    currentPath === STRING_CONSTANTS.navigationString.index
                      ? "active"
                      : ""
                  }
                >
                  <Link to={STRING_CONSTANTS.navigationString.index}>
                    Home
                  </Link>
                </li>
                <li>
                  <a href="/accounts/signup">Signup</a>
                </li>
              </ul>
              <div className="auth-buttons">
                <Link to="/signin">
                  <button className="login">Login</button>
                </Link>
                <Link to={signupPath}>
                  <button className="signup">Signup</button>
                </Link>
              </div>
            </>
          )}
        </>
      )}
    </header>
  );
}

export default CBAHeader;
